import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import ScheduledOffersTable from '../../modules/scheduled-offers/components/ScheduledOffersTable';

export const ScheduledOffersPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'scheduledOffers.title' })}
      </PageTitle>
      <ScheduledOffersTable />
    </>
  );
};
